import { notEmptyOrNil } from 'shared/helpers/functional'
import { remove } from 'js-cookie'
import {
  isAnyAdmin,
  isResponder,
  setAuthCookies,
  setAuthForUrls,
  storage,
} from 'shared/helpers/user'
import Storage from 'shared/helpers/storage'

export function removeAuthCookies () {
  Storage.removeItem("accessToken");
  Storage.removeItem("x-api-key")
}

export function redirectToLogin () {
  removeAuthCookies()
  window.location.href=`/`
}

export function getAuthCookies () {
  return {
    id: storage.getId(),
    token: storage.getToken(),
  }
}

export function hasAuthCookies () {
  const { id, token } = getAuthCookies()

  return [id, token].every(notEmptyOrNil)
}

/**
 * TODO - consider moving - this seems too general to be scoped in /qual
 * Is there any reason we would set tokens other than /login?
 */
export function setAuthentication (user) {
  const predicatesAndUrls = [
    [true, '/login/'],
    [isResponder, '/responder/'],
    [isAnyAdmin, '/admin/'],
  ]
  setAuthForUrls(predicatesAndUrls, user)
  setAuthCookies({ id: user.id, token: user.accessToken })
}

export const genAuthHeaders = (contentType) => {
  const { id, token } = getAuthCookies()

  return Object.assign({
    'IC-Auth': `${id}:${token}`,
  }, contentType === 'application/json' ? {'Content-Type': 'application/json'} : {})
}
